import React from 'react';
import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Alert from 'reactstrap/lib/Alert';

import { receiveTickets, requestLocations, receiveProducts } from '@ttstr/actions';
import { getLocationFromProduct } from '@ttstr/reducers/locations';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import { AppState } from '@ttstr/reducers';

import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { ContentrArea, Container, LoadingSpinner, Masonry, useIntl, MakiGIF } from '@ttstr/components';

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products, tickets, locations, locationsReceived } = useShallowEqualSelector(mapStateToProps);
  const { receiveTickets, requestLocations, receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  if (!locations) debugger;

  React.useEffect(() => {
    receiveTickets();
    requestLocations();
    receiveProducts();
  }, [language]);

  return (
    <article className="my-5">
      <Helmet>
        <body className="landing-page" />
      </Helmet>

      <Container fluid className="header-image mb-5" />

      <Container className="list-page my-5">
        <Helmet>
          <title>{t(`TICKETLISTING.TITLE`)}</title>
        </Helmet>

        <h1 className="my-5">{t(`TICKETS`)}</h1>

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.TICKETS`)} />
        ) : tickets.length === 0 ? ( // if no tickets
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show tickets
          <Masonry id="ticket-listing" products={tickets} type="list" showLocation showCity />
        )}
      </Container>

      <Container className="list-page py-5">
        <h1 className="my-5">{t(`MERCHANDISE`)}</h1>
        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info">{t(`MASONRY.NO_ITEMS`)}</Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            products={products.filter((p) => !p.tag_ids.includes(9271))}
            filters="off"
            columnClassName="col-6 col-lg-4 p-0 m-0"
            showSubtitle
            type={MakiGIF}
            // itemClassName="random-rotation-object"
            // itemImageClassName="scribble-hover-overlay-object"
          />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { tickets, loading } = state.Tickets;
  const { locations, locationsReceived } = state.Locations;
  const { products } = state.Products;
  return {
    tickets,
    products,
    loading,
    locations,
    locationsReceived,
  };
};

const mapDispatchToProps = {
  receiveTickets,
  receiveProducts,
  requestLocations,
};

export default React.memo(Home);
